import { Webhook } from "lucide-react";
import SettingsSection from "./SettingsSection";

export default function WebhooksSection({ webhooks, onEdit, onAdd }) {
  return (
    <SettingsSection
      icon={Webhook}
      title="Webhooks"
      description="Configure webhook endpoints for real-time events"
    >
      <div className="space-y-3">
        {webhooks.map((webhook) => (
          <div
            key={webhook.id}
            className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
          >
            <div>
              <p className="text-sm font-medium text-gray-900 mb-2">
                {webhook.url}
              </p>
              <div className="flex items-center gap-2">
                {webhook.events.map((event, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded"
                  >
                    {event}
                  </span>
                ))}
                <span
                  className={`px-2 py-1 text-xs font-medium rounded ${
                    webhook.status === "active"
                      ? "text-green-700 bg-green-100"
                      : "text-gray-600 bg-gray-100"
                  }`}
                >
                  {webhook.status === "active" ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
            <button
              onClick={() => onEdit(webhook)}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Edit
            </button>
          </div>
        ))}
        <button
          onClick={onAdd}
          className="w-full py-3 text-sm font-medium text-gray-600 border border-gray-200 border-dashed rounded-lg hover:bg-gray-50 transition-colors"
        >
          Add Webhook
        </button>
      </div>
    </SettingsSection>
  );
}
